import React from 'react'

const stroke = 'currentColor'
const fill = 'currentColor'

export const SkillIcon = ({ name, size = 22, className }) => {
  const common = { width: size, height: size, role: 'img', 'aria-label': name, className }
  switch ((name || '').toLowerCase()) {
    case 'react':
      return (
        <svg {...common} viewBox="0 0 24 24"><title>React</title><g fill="none" stroke={stroke} strokeWidth="1.5"><circle cx="12" cy="12" r="2.2"/><ellipse cx="12" cy="12" rx="10" ry="4.6" transform="rotate(60 12 12)"/><ellipse cx="12" cy="12" rx="10" ry="4.6" transform="rotate(-60 12 12)"/><ellipse cx="12" cy="12" rx="10" ry="4.6"/></g></svg>
      )
    case 'python':
      return (
        <svg {...common} viewBox="0 0 24 24"><title>Python</title><path fill={fill} opacity=".1" d="M7 4h6a3 3 0 0 1 3 3v3H9a3 3 0 0 0-3 3v3H7a3 3 0 0 0 3-3V7H7Z"/><circle cx="10" cy="6.5" r=".9" fill={fill}/><path stroke={stroke} strokeWidth="1.5" d="M7 4h6a3 3 0 0 1 3 3v3M17 20h-6a3 3 0 0 1-3-3v-3"/></svg>
      )
    case 'github':
      return (
        <svg {...common} viewBox="0 0 24 24"><title>GitHub</title><path d="M12 3a9 9 0 0 0-3 17.5c.5.1.7-.2.7-.5v-2c-2.8.6-3.4-1.2-3.4-1.2-.5-1.1-1.2-1.4-1.2-1.4-.9-.6.1-.6.1-.6 1 .1 1.6 1 1.6 1 .9 1.6 2.5 1.1 3 .9.1-.7.4-1.1.7-1.4-2.2-.2-4.6-1.1-4.6-5a3.9 3.9 0 0 1 1-2.7c-.1-.2-.4-1.3.1-2.7 0 0 .8-.3 2.8 1a9.5 9.5 0 0 1 5 0c2-1.3 2.8-1 2.8-1 .5 1.4.2 2.5.1 2.7a3.9 3.9 0 0 1 1 2.7c0 3.9-2.4 4.8-4.6 5 .4.3.7.9.7 1.8v2.7c0 .3.2.6.7.5A9 9 0 0 0 12 3Z" fill={fill}/></svg>
      )
    case 'live':
      return (
        <svg {...common} viewBox="0 0 24 24"><title>Live Demo</title><rect x="4" y="5" width="16" height="10" rx="2" stroke={stroke} strokeWidth="1.5" fill="none"/><path d="M8 19h8" stroke={stroke} strokeWidth="1.5"/></svg>
      )
    case 'case-study':
      return (
        <svg {...common} viewBox="0 0 24 24"><title>Case Study</title><path d="M6 5h9l3 3v11a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z" stroke={stroke} strokeWidth="1.5" fill="none"/><path d="M15 5v3h3" stroke={stroke} strokeWidth="1.5"/></svg>
      )
    default:
      return (
        <svg {...common} viewBox="0 0 24 24"><title>{name}</title><circle cx="12" cy="12" r="9" stroke={stroke} strokeWidth="1.5" fill="none"/></svg>
      )
  }
}

export default SkillIcon

